import Vue from 'vue';
import Vuex from 'vuex';
import common from './modules/common';
import addMoreGood from './modules/addMoreGood';
import cart from './modules/cart';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    common,
    addMoreGood,
    cart
  },
  strict: debug
});
